module.exports = __webpack_public_path__ + "static/img/active8.76297215.png";